import { PolicyPremiumBreakupDO } from './../../../BaseFramework/shared/models/PolicyPremiumBreakup.model';
import { PolicyCoverageScheduleDO } from './../../../FunctionalModules/PolicyIssuance/models/PolicyCoverageSchedule.model';
import { NewBusinessAppSettings } from './../../Newbusiness/newbusiness-configs/newbusiness-app-settings.config';
import { WorkqueueService } from './../../../BaseFramework/core/http/workqueue.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { MetadataService } from './../../../BaseFramework/core/http/metadata.service';
import {
  LookupDataService,
  CommonUtilty,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { PolicyCoverageDO } from './../../../BaseFramework/shared/models/other/policyCoverageDO'
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { ProposalCoverageInsuredDO } from 'app/BaseFramework/shared/models/proposal/proposalCoverageInsuredDO';


@Component({
  selector: 'app-product-coverages',
  templateUrl: './product-coverages.component.html',
  styleUrls: ['./product-coverages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductCoveragesComponent implements OnInit, OnDestroy {

 
  @Input() title: string
  @Input() configData
  @Input() product;

  _currentComponentName = "ProductCoveragesComponent"

  refreshBasePlanToggle = true;
  basePlanComponentData = {};
  mandatoryCoverageComponentData = [];
  additionalCoveragesComponentData = [];
  fundAllocationComponentData = {};
  insuredList = [];
  coveragesList: any = [];
  coverages = [];
  fetchingFormData = true
  
  constructor(private viewContainerRef: ViewContainerRef,
    private commonUtilty: CommonUtilty,
    private lookupDataService: LookupDataService,
    public interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
    public newBusinessAppSettings: NewBusinessAppSettings,
    public metadataService: MetadataService,) { }

  
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'decisionCd', 'paymentMethodCd', 'paymentModeCd', 'paymentFrequencyCd']
  selectorOfThisComponent = 'app-product-coverages'
  parentEvent$
  productData = []
  payloadForMandatoryCoverages = null;
  payloadForAdditionalCoverages = null;

  @Output() componentOutput = new EventEmitter<any>();
  @Input() transactionState: string;
  @Input() transformType: string
  @Output() changedField = new EventEmitter<any>();
  
  formDataChangeHandler(fieldKey){
    this.changedField.emit(fieldKey);
  }

  EmitChangedField(data){
    this.changedField.emit(data);
  }

  public _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value){
      if (this.transformType == 'LIFE')
      this._inputDataForEdit = this.LifeServerToUITransform(value);
      else if (this.transformType == 'HEALTH')
      this._inputDataForEdit = this.HealthServerToUITransform(value);
    } 
  };

  get inputDataForEdit() {
    return this._inputDataForEdit;
  }

  /**UR : need to check below function**/
  @Output() basePlanComponentOutput = new EventEmitter<any>();
  basePlanComponentOutputHandler(data) {
    this.basePlanComponentOutput.emit(data)
  }

  LifeEmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.LifeUItoServerTransform)
    console.log("product coverages component output", c);
  }

  HealthEmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.HealthUItoServerTransform)
    console.log("product coverages component output", c);
  }

  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.additionalCoveragesComponentData = this.mapAllCoveragesToPayload(this.additionalCoverageList , this.additionalCoveragesComponentData)
      let componentOutput = {
        BasePlan: this.basePlanComponentData,
        MandatoryCoverages: this.mandatoryCoverageComponentData,
        AdditionalCoverages: this.additionalCoveragesComponentData,
        insuredList: this.lookupDataService.lookupCacheMap['insuredCd'] || []
      }
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let validationResult = {isInvalid : false};
        if (!validationResult.isInvalid) {
          let allLOB = "MOTOR,TRAVEL,PROPERTY,HEALTH"
          if (allLOB.includes(this.transformType))
            this.HealthEmitComponentOutput(componentOutput);
          else if (this.transformType === 'LIFE')
            this.LifeEmitComponentOutput(componentOutput)
        } else {
          this.HealthEmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  insuredlistSubject$;
  currentDO : string;
  ngOnInit() {
    this.currentDO = this.configData && this.configData.StateToDOMapper && this.configData.StateToDOMapper[this.transactionState] ? this.configData.StateToDOMapper[this.transactionState] : 'proposalDO'
    this.updateConfigData();
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOdynamicutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
  
    this.subscribeToParentEvent()
    this.fetchProducts();

    if (this.toggleBasePlanSubject$ != null) this.toggleBasePlanSubject$.unsubscribe();
    this.toggleBasePlanSubject$ = this.interactService.refreshBasePlanSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshBasePlanComponent();
    })

    if (this.refreshCoverageSubject$ != null) this.refreshCoverageSubject$.unsubscribe();
    this.refreshCoverageSubject$ = this.interactService.refreshCoverageSubject$.subscribe(val => {
      if (val) {
        console.log("this.inputDataForEdit",this.inputDataForEdit);
        this.inputDataForEdit.proposalDO.proposalCoverages = []; // resetting the addon coverages Array in payload.
        this.additionalCoveragesComponentData = [];
        this.product = this.commonUtilty.deepCopy(val[0]);
        this.updateConfigData();
        this.generateUIcoverageBenefitTree();
        this.generateUIcoverageBenefitForPanel();
        this._toggleRefreshCoverageComponent();
      }
    })
  }

  ngOnDestroy() {
    this.metadataService.productBasedConfigData = [];
   }

 
  private _mandatoryCoverageObjList = [];
  public get mandatoryCoverageObjList() {
    return this._mandatoryCoverageObjList;
  }

  public set mandatoryCoverageObjList(value) {
    this._mandatoryCoverageObjList = value;
  }

  additionalCoverageObjList = [];
  additionalCoverageList = [];

  updateConfigData(){
    if(this.commonUtilty.isArrayIterable(this.metadataService.productBasedConfigData)){
    this.additionalCoverageObjList = [];
    this.additionalCoverageList = [];
    this.metadataService.productBasedConfigData.forEach((element,index) => {
      if(!element.uiConfigurations) element.uiConfigurations = [];
      if(element.associationTypeCd == 'MANDATORY'){
        let isRiderCdAvailable = element.uiConfigurations ? element.uiConfigurations.find(item => item.fieldKey == 'riderCd'): undefined;
        if(!isRiderCdAvailable){
          let coverageNameHiddenField = this.createUiConfigHiddenField(element);
          element.uiConfigurations.push(coverageNameHiddenField);
        }
        element.uiConfigurations = this.updateUIMappingOfConfigForCoverage(element.uiConfigurations, index, "mandatoryCoverages", "mandatoryCoveragesArray");
        this.mandatoryCoverageObjList.push(element);
      }else if(element.associationTypeCd == 'OPTIONAL'){
        let isRiderCdAvailable = element.uiConfigurations ? element.uiConfigurations.find(item => item.fieldKey == 'riderCd'): undefined;
        if(!isRiderCdAvailable){
          let coverageNameHiddenField = this.createUiConfigHiddenField(element);
          element.uiConfigurations.push(coverageNameHiddenField);
        }
        element.uiConfigurations = this.updateUIMappingOfConfigForAdditionalCoverage(element.uiConfigurations,index, "additionalCoverages", "additionalCoveragesArray",this._inputDataForEdit,element.productCd);
        this.additionalCoverageObjList.push(element);
      }else{
        let updateUIConfig = this.updateUIMappingOfConfig(element.uiConfigurations); //Temporary added as backend suppor is not available
        this.configData.ComponentMetaDataConfiguration.BasePlanComponent = updateUIConfig;
        this._toggleRefreshBasePlanComponent();
      }
    });
    this.fetchingFormData = false;
    }else{
    if(this.inputDataForEdit && this.inputDataForEdit[this.currentDO] && this.inputDataForEdit[this.currentDO]['baseProductCd']){
      this.workqueueService.fetchUIMetadata(this.inputDataForEdit[this.currentDO]['baseProductCd']).subscribe(response => {
        this.metadataService.productBasedConfigData = response || [];
        this.updateConfigData();
      })
    }
    }
    this.additionalCoverageList = this.commonUtilty.deepCopy(this.additionalCoverageObjList)
  }

  createUiConfigHiddenField(element){
    let obj = {};
    obj['fieldKey'] = "riderCd";
    obj['fieldGenericMapping'] = "";
    obj['fieldMapping'] = "riderCd";
    obj['fieldName'] = "Rider";
    obj['fieldType'] = "INPUT";
    obj['objectName'] = "UIFieldConfigurationDO";
    obj['owner'] = "COMPUTED";
    obj['productCd'] = element.productCd;
    obj['defaultValue'] = element.riderCd;
    obj['readOnly'] = true;
    obj['visible'] = false;
    obj['hidden'] = true;
    return obj;
  }

   updateUIMappingOfConfig(uiConfig){
    if(this.commonUtilty.isArrayIterable(uiConfig)){
      uiConfig.forEach(element => {
        if(element.fieldKey == 'productOption'){
          element.fieldKey = 'planCd';
        }
        element['extractElementFromArray'] = true;
        element['fieldGenericMapping'] = "baseDO-"+element.fieldKey;
        element['fieldMapping'] = this.currentDO +"-"+element.fieldKey;
      });
    }
    return uiConfig;
  }

  updateUIMappingOfConfigForCoverage(uiConfig,index, fieldKey, parentFormArray){
    if(this.commonUtilty.isArrayIterable(uiConfig)){
      let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
      uiConfig.forEach(element => {
        element['fieldMapping'] = this.currentDO + "-"+CoveragesNode+"-"+index+"-"+element['fieldKey'];
        element['fieldGenericMapping'] = "baseDO-"+CoveragesNode+"-"+index+"-"+element['fieldKey'];
        element['parentFormArray'] = parentFormArray;
      });
    }
    return uiConfig;
  }

  updateUIMappingOfConfigForAdditionalCoverage(uiConfig, index, fieldKey, parentFormArray, IO, rider){
    let DO = this.commonUtilty.getDOName(IO)
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    if(this.commonUtilty.isArrayIterable(uiConfig) && rider){
      let coverageList = this.currentDO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages';
      uiConfig.forEach(element => {
        if(IO && IO[DO] && IO[DO] && this.commonUtilty.isArrayIterable(IO[DO][CoveragesNode])){
          // any one product needs to same as rider product
          let foundIndex = IO[DO][CoveragesNode].findIndex(item=>(rider == item.productCd))
          if(foundIndex != -1){
            element['fieldMapping'] = this.currentDO + "-"+coverageList+"-"+index+"-"+element['fieldKey'];
            element['fieldGenericMapping'] = "baseDO-"+coverageList+"-"+index+"-"+element['fieldKey'];
            element['parentFormArray'] = parentFormArray;
          }
        }
      });
    }
    return uiConfig;
  }

  fetchProducts() {
    this.workqueueService.fetchProducts(this.transformType)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }
          })
        }
        this.generateUIcoverageBenefitTree();
        this.generateUIcoverageBenefitForPanel();
        console.log("product data when fetching from API", JSON.stringify(this.productData));
      })
  }

  LifeUItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    let CoveragesNode =  DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages'; 
    let CoveragesInsuredNode = DO == 'caseDO' ? 'caseCoverageInsureds' : 'proposalCoverageInsureds';
    let CoveragesScheduleNode = DO == 'caseDO' ? 'caseCoverageSchedules' : 'proposalCoverageSchedules';
    let ClientListNode = DO == 'caseDO' ? 'caseClients' : 'proposalClients';
    let clientGuid = null;
    let clientId = null;
    let basePlan = [];
    let mandatoryCoverages = [];
    let additionalCoverages = [];
    if (payload && payload[DO]) {
      if(!response.componentData.BasePlan['BasePlanComponent']){
        response.componentData.BasePlan['BasePlanComponent'] = {};
      }
      response.componentData.BasePlan.BasePlanComponent['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'] || payload[DO]['policyTerm'];
      // base plan transform starts
      let clientList = DO == 'caseDO' ? (payload[DO].caseClients || []) : (payload[DO].proposalClients || []);
      let policyClient = clientList.find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient ? policyClient.clientRefGuid : null;
      clientId = policyClient ? policyClient.clientId : null;
      let foundIndex = payload[DO][CoveragesNode].findIndex(item => item.planTypeCd === 'BASEPLAN')
      if (foundIndex == -1) {
        let coverageInsured = new ProposalCoverageInsuredDO();
        coverageInsured.clientRefGuid = clientGuid;
        coverageInsured.roleCd = "PRIMARYINSURED";
        let coverageInsuredList = [coverageInsured];
        let policyTerm,productCd;
        if(response && response.componentData && response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];          
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = [];
          policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
          payload[DO]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
        }
        let coverageSchedule = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')
        if (coverageSchedule && coverageSchedule[CoveragesScheduleNode] && policyTerm === coverageSchedule[CoveragesScheduleNode].length) {
          // do nothing
        } else {
          if(response && response.componentData && response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
            response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
            basePlan = [response.componentData.BasePlan.BasePlanComponent];
          }
        }
      } else {
        if (response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent) {
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          
          let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          let productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
          
          response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
          
          let foundBasePlan = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = foundBasePlan[CoveragesInsuredNode];
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt']; 
          payload[DO]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
      }

      // add insureds to base plan
      if(response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
          // response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = [];
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         }
         basePlan = [response.componentData.BasePlan.BasePlanComponent];
      }

      if(response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
         if(payload && payload[DO] && payload[DO][CoveragesNode] && this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])){
          let basePlanCoverageData = payload[DO][CoveragesNode].find(cov => cov.planTypeCd === 'BASEPLAN');
          if(basePlanCoverageData) {
           basePlanCoverageData['sumInsuredAmt'] = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt']
           basePlanCoverageData['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd']
           basePlan = [basePlanCoverageData];
          }
        }
        else basePlan = [response.componentData.BasePlan.BasePlanComponent]
      }

      // add insureds to mandatory coverages
      if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
        response.componentData.MandatoryCoverages.forEach((mandatoryCov) => {
          mandatoryCov[CoveragesInsuredNode] = [];
          mandatoryCov['associationTypeCd'] = 'MANDATORY';
          mandatoryCov['planTypeCd'] = 'RIDER';
          mandatoryCov['productCd'] = mandatoryCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = mandatoryCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              mandatoryCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        mandatoryCoverages =response.componentData.MandatoryCoverages;
      }

      // add insureds to additional coverages
      if(this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)){
        response.componentData.AdditionalCoverages.forEach((additionalCov) => {
          additionalCov[CoveragesInsuredNode] = [];
          additionalCov['associationTypeCd'] = 'OPTIONAL';
          additionalCov['planTypeCd'] = 'RIDER';
          additionalCov['productCd'] = additionalCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = additionalCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              additionalCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        if (payload && payload[DO] && payload[DO][CoveragesNode] && this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
          payload[DO][CoveragesNode].forEach(cov => {
            if (cov.planTypeCd === 'RIDER') {
              const matchingRider = response.componentData.AdditionalCoverages.find(
                additionalCover => additionalCover.productCd === cov.productCd
              );

              if (matchingRider) {
                cov['term'] = matchingRider['term'];
                cov['sumInsuredAmt'] = matchingRider['sumInsuredAmt'];
                if(!cov[CoveragesInsuredNode])
                  cov[CoveragesInsuredNode].push(...matchingRider[CoveragesInsuredNode]);
                additionalCoverages = [cov];
              }
            }
          });
        }
         additionalCoverages = response.componentData.AdditionalCoverages;
      }
	  
      //additional coverages transform end
      // let coverages = [...basePlan, ...mandatoryCoverages, ...additionalCoverages];
      // payload[DO][CoveragesNode] = this.commonUtilty.deepCopy(coverages);

      // add commencement and expiry date to payload
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach(coverage => {
          if(payload[DO] && payload[DO].policyCommencementDt && coverage){
            if(!coverage.commencementDt){
              coverage.commencementDt = null;
            }
              coverage.commencementDt = payload[DO].policyCommencementDt;
          }
          if(payload[DO] && payload[DO].policyExpiryDt && coverage){
            if(!coverage.expiryDt){
              coverage.expiryDt = null;
            }
              coverage.expiryDt = payload[DO].policyExpiryDt;
          }
        });
      }
      
      if (!this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        let coverages = [...basePlan, ...mandatoryCoverages, ...additionalCoverages];
        payload[DO][CoveragesNode] = this.commonUtilty.deepCopy(coverages);
      }

      // add premium breakup to payload
      let premiumBreakup = new PolicyPremiumBreakupDO();
      if (DO != 'caseDO')
        payload[DO]['proposalPremiumBreakups'].push(premiumBreakup);
      else {
        payload[DO]['casePremiumBreakups'].push(premiumBreakup);
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }

    return payload
  }

  HealthUItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    let CoveragesNode = DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages';
    let PaymentNode = DO == 'caseDO' ? 'casePayments' : 'proposalPayments';
    let ClientListNode = DO == 'caseDO' ? 'caseClients' : 'proposalClients';
    let CoveragesInsuredNode = DO == 'caseDO' ? 'caseCoverageInsureds' : 'proposalCoverageInsureds';
    let CoveragesScheduleNode = DO == 'caseDO' ? 'caseCoverageSchedules' : 'proposalCoverageSchedules';
    let clientGuid = null;
    let clientId = null;
    let basePlan = [];
    let mandatoryCoverages = [];
    let additionalCoverages = [];

    if (payload && payload[DO]) {
      if(!response.componentData.BasePlan['BasePlanComponent']){
        response.componentData.BasePlan['BasePlanComponent'] = {};
      }
      response.componentData.BasePlan.BasePlanComponent['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'] || payload[DO]['policyTerm'];
      response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'] = response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'] || payload[DO]['premiumPaymentTerm'];
      response.componentData.BasePlan.BasePlanComponent['productOption'] = response.componentData.BasePlan.BasePlanComponent['productOption'] || payload[DO]['productOption'];
      response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'] = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'] || payload[DO]['sumInsuredAmt'];
      payload[DO]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
      if(!this.commonUtilty.isArrayIterable(payload[DO][PaymentNode])){
        payload[DO][PaymentNode].push({'paymentFrequencyCd' : null});
      }
      payload[DO][PaymentNode][0]['paymentFrequencyCd'] = response.componentData.BasePlan.BasePlanComponent['paymentFrequencyCd'];
      payload[DO]['policyTerm'] = response.componentData.BasePlan.BasePlanComponent['policyTerm'];
      payload[DO]['premiumPaymentTerm'] = response.componentData.BasePlan.BasePlanComponent['premiumPaymentTerm'];
      payload[DO]['productOption'] = response.componentData.BasePlan.BasePlanComponent['productOption'];
      payload[DO]['sumInsuredAmt'] = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
      
      // base plan transform starts
      let policyClient = payload[DO][ClientListNode].find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient ? policyClient.clientRefGuid : null;
      clientId = policyClient ? policyClient.clientId : null;
      let foundIndex = payload[DO][CoveragesNode].findIndex(item => item.planTypeCd === 'BASEPLAN')
      if (foundIndex == -1) {
        let coverageInsured = new ProposalCoverageInsuredDO();
        coverageInsured.clientRefGuid = clientGuid;
        coverageInsured.roleCd = "PRIMARYINSURED";
        let coverageInsuredList = [coverageInsured];
        response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];        
        response.componentData.BasePlan.BasePlanComponent['productTypeCd'] = payload[DO]['productPlanOptionCd'];
        response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
        response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
        response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
        response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = this.commonUtilty.deepCopy(coverageInsuredList);
        let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
        let productCd = response.componentData.BasePlan.BasePlanComponent.productCd;
        payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
        let coverageSchedule = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')

        if (coverageSchedule && coverageSchedule[CoveragesScheduleNode] && policyTerm === coverageSchedule[CoveragesScheduleNode].length) {
          // do nothing
        } else {
          response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
      } else {
        if (response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent) {
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['productCd']=payload[DO]['baseProductCd'];
          let policyTerm = response.componentData.BasePlan.BasePlanComponent.policyTerm;
          let productCd = response.componentData.BasePlan.BasePlanComponent.planOptionCd;

          response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode] = [];
          if (policyTerm && productCd) {
            for (let i = 0; i < policyTerm; i++) {
              let policyCoverageSchedule = new PolicyCoverageScheduleDO();
              policyCoverageSchedule.productTypeCd = productCd;
              policyCoverageSchedule.policyYear = i + 1;
              response.componentData.BasePlan.BasePlanComponent[CoveragesScheduleNode].push(policyCoverageSchedule);
            }
          }
          let foundBasePlan = payload[DO][CoveragesNode].find(item => item.planTypeCd === 'BASEPLAN')
          response.componentData.BasePlan.BasePlanComponent['planOptionCd'] = payload[DO]['productPlanOptionCd'];
          response.componentData.BasePlan.BasePlanComponent['planTypeCd']= "BASEPLAN";
          response.componentData.BasePlan.BasePlanComponent['packageCd'] = payload[DO]['packageCd'];
          response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = foundBasePlan[CoveragesInsuredNode];
          payload[DO].sumInsuredAmt = response.componentData.BasePlan.BasePlanComponent['sumInsuredAmt'];
          basePlan = [response.componentData.BasePlan.BasePlanComponent];
        }
      }
      // base plan transform end

      // add insureds to base plan
      if(response.componentData.BasePlan && response.componentData.BasePlan.BasePlanComponent){
        response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode] = [];
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              response.componentData.BasePlan.BasePlanComponent[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         }
         if(payload && payload[DO] && payload[DO][CoveragesNode] && payload[DO][CoveragesNode][0]){
           let basePlanCoverageData = payload[DO][CoveragesNode].find(item => item.planTypeCd == 'BASEPLAN');
           basePlanCoverageData['baseAnnualPremiumAmt'] = payload[DO]['baseAnnualPremiumAmt'] || basePlanCoverageData['baseAnnualPremiumAmt']  
           basePlanCoverageData['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] || basePlanCoverageData['sumInsuredAmt']
           basePlan = [basePlanCoverageData];
        }
        else basePlan = [response.componentData.BasePlan.BasePlanComponent]
      }

      // add insureds to mandatory coverages
      if(this.commonUtilty.isArrayIterable(response.componentData.MandatoryCoverages)){
        response.componentData.MandatoryCoverages.forEach((mandatoryCov) => {
          mandatoryCov[CoveragesInsuredNode] = [];
          mandatoryCov['associationTypeCd'] = 'MANDATORY';
          mandatoryCov['planTypeCd'] = 'RIDER';
          mandatoryCov['productCd'] = mandatoryCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = mandatoryCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              mandatoryCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        mandatoryCoverages =response.componentData.MandatoryCoverages;
      }

      // add insureds to additional coverages
      if(this.commonUtilty.isArrayIterable(response.componentData.AdditionalCoverages)){
        response.componentData.AdditionalCoverages.forEach((additionalCov) => {
          additionalCov[CoveragesInsuredNode] = [];
          additionalCov['associationTypeCd'] = 'OPTIONAL';
          additionalCov['planTypeCd'] = 'RIDER';
          additionalCov['productCd'] = additionalCov.riderCd;
         if(payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][ClientListNode])){
          payload[DO][ClientListNode].forEach(insured => {
            let isExist = additionalCov[CoveragesInsuredNode].find(item => item.clientRefGuid == insured.clientRefGuid);
            if(!isExist && (insured.roleCd != 'NOMINEE' && insured.roleCd != 'OWNER')){
              let coverageInsureds = new ProposalCoverageInsuredDO();
              coverageInsureds.clientRefGuid = insured.clientRefGuid;
              coverageInsureds.roleCd = insured.roleCd;
              additionalCov[CoveragesInsuredNode].push(coverageInsureds);
            }
          });
         } 
        });
        additionalCoverages =response.componentData.AdditionalCoverages;
      }
      //additional coverages transform end

      let coverages = [...basePlan, ...mandatoryCoverages, ...additionalCoverages];
      payload[DO][CoveragesNode] = this.commonUtilty.deepCopy(coverages);

      // add commencement and expiry date to payload
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach(coverage => {
          if(payload[DO] && payload[DO].policyCommencementDt  && coverage){
            if(!coverage.commencementDt){
              coverage.commencementDt = null;
            }
              coverage.commencementDt = payload[DO].policyCommencementDt;
          }
          if(payload[DO] && payload[DO].policyExpiryDt  && coverage){
            if(!coverage.expiryDt){
              coverage.expiryDt = null;
            }
              coverage.expiryDt = payload[DO].policyExpiryDt;
          }
        });
      }

      // add premium breakup to payload
      let premiumBreakup = new PolicyPremiumBreakupDO();
      if (DO != 'caseDO')
        payload[DO]['proposalPremiumBreakups'].push(premiumBreakup);
      else {
        payload[DO]['casePremiumBreakups'].push(premiumBreakup);
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  mapAllCoveragesToPayload(coverageObjList ,payloadCoverageList){
    let finalPayloadCoverageList = []
    if(coverageObjList && this.commonUtilty.isArrayIterable(coverageObjList) && coverageObjList.length){
      coverageObjList.forEach((coverage) => {
        console.log(coverage, payloadCoverageList)
        let existingCov = payloadCoverageList.filter(cov =>(cov.productCd || cov.riderCd) == coverage.riderCd)
        if(existingCov && existingCov.length){
          existingCov[0]['riderCd'] = coverage.riderCd
          finalPayloadCoverageList = this.commonUtilty.uniquePushInArray(finalPayloadCoverageList, existingCov[0] , 'riderCd')
        }
        else {
          let cover = {
            "sumInsuredAmt": 0,
            "baseAnnualPremiumAmt": null,
            "riderCd": coverage.riderCd
          }
          finalPayloadCoverageList = this.commonUtilty.uniquePushInArray(finalPayloadCoverageList, cover , 'riderCd')
        }
      })
    }
    return finalPayloadCoverageList;
  }

  convertCoverageValueToString(payload , DO){
    let coverageList = DO == 'caseDO' ? 'caseCoverages' : 'proposalCoverages'; 
    if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][coverageList])){
      payload[DO][coverageList].forEach(element => {
        element['sumInsuredAmt'] = element['sumInsuredAmt'] ? element['sumInsuredAmt'].toString() : element['sumInsuredAmt'];
      });
    }
    return payload;
  }

  LifeServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    this.payloadForMandatoryCoverages = this.commonUtilty.deepCopy(payload);
    this.payloadForAdditionalCoverages = this.commonUtilty.deepCopy(payload);
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'] ? payload[DO]['policyTerm'].toString() : '';
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'];
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.transactionState];
    payload[DO]['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] || payload[DO][CoveragesNode][0]['sumInsuredAmt']
    this.mandatoryCoverageComponentData = this.lifeCoveragesServertoUITransformHandler(this.payloadForMandatoryCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'MANDATORY')
    this.additionalCoveragesComponentData = this.lifeCoveragesServertoUITransformHandler(this.payloadForAdditionalCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'OPTIONAL')
    return payload;
  }

  HealthServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    this.payloadForMandatoryCoverages = this.commonUtilty.deepCopy(payload);
    this.payloadForAdditionalCoverages = this.commonUtilty.deepCopy(payload);
    let CoveragesNode = this.configData.CoverageNodeMapper[this.transactionState];
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'] ? payload[DO]['policyTerm'].toString() : '';
    payload[DO]['policyTerm'] = payload[DO]['policyTerm'];
    payload[DO]['sumInsuredAmt'] = payload[DO]['sumInsuredAmt'] || payload[DO][CoveragesNode][0]['sumInsuredAmt']
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.transactionState];
    this.mandatoryCoverageComponentData = this.HealthCoveragesServertoUITransformHandler(this.payloadForMandatoryCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'MANDATORY')
    this.additionalCoveragesComponentData = this.HealthCoveragesServertoUITransformHandler(this.payloadForAdditionalCoverages, DO, CoveragesNode, CoveragesInsuredNode, 'OPTIONAL')
    payload = this.convertCoverageValueToString(payload, DO);
    return payload;
  }

  lifeCoveragesServertoUITransformHandler(payload, DO, CoveragesNode, CoveragesInsuredNode, transformFor) {
    let list = [];
    if (payload && payload[DO]) {
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach((coverage) => {
          if (coverage.planTypeCd != 'BASEPLAN' && coverage.associationTypeCd == transformFor) {
            if (transformFor == 'OPTIONAL') {
              let coverageInsured = coverage[CoveragesInsuredNode].find(() => true)
              if(coverageInsured)
              coverage['clientRefGuid'] = coverageInsured.clientRefGuid;
              // list.push(coverage);
            }
            if (coverage.associationTypeCd == 'MANDATORY') {
              // if (this.commonUtilty.isArrayIterable(list)) {
              let foundIndex = list.findIndex(item => item.productCd == coverage.productCd)
              if (foundIndex == -1)
                list.push(coverage);
              // }
            } else
              list.push(coverage);
          }
        })
      }
    }
    if (transformFor == 'MANDATORY') {
      let mclist = list.filter(item => item.associationTypeCd === 'MANDATORY')
      if (this.commonUtilty.isArrayIterable(mclist)) { }
      else {
        if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'])) {
          this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'].forEach(lookup => {
            let mc = new PolicyCoverageDO();
            mc.productCd = lookup.lookupKey;
            mc.planTypeCd = 'RIDER';
            mc.associationType = 'MANDATORY';
            list.push(mc);
          });
        }
      }
    }
    return list;
  }

  HealthCoveragesServertoUITransformHandler(payload, DO, CoveragesNode, CoveragesInsuredNode, transformFor) {
    let list = [];
    if (payload && payload[DO]) {
      if (this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])) {
        payload[DO][CoveragesNode].forEach((coverage) => {
          if (coverage.planTypeCd != 'BASEPLAN' && coverage.associationTypeCd == transformFor) {
            // one to one mapping logic
            if (transformFor == 'OPTIONAL') {
              let coverageInsured = coverage[CoveragesInsuredNode].find(() => true)
              if(coverageInsured)
              coverage['clientRefGuid'] = coverageInsured.clientRefGuid;
              coverage.sumInsuredAmt = coverage.sumInsuredAmt ? coverage.sumInsuredAmt.toString(): coverage.sumInsuredAmt;
              list.push(coverage);
            }
            if (coverage.associationTypeCd == 'MANDATORY') {
              coverage.sumInsuredAmt = coverage.sumInsuredAmt ? coverage.sumInsuredAmt.toString(): coverage.sumInsuredAmt;
              list.push(coverage);
            }
          }
        })
      }
    }

    if (transformFor == 'MANDATORY') {
      let mclist = list.filter(item => item.associationTypeCd === 'MANDATORY')
      if (this.commonUtilty.isArrayIterable(mclist)) { }
      else {
        if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'])) {
          this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'].forEach(lookup => {
            let mc = new PolicyCoverageDO();
            mc.productCd = lookup.lookupKey;
            mc.planTypeCd = 'RIDER';
            mc.associationType = 'MANDATORY';
            list.push(mc);
          });
        }
      }
    }
    return list;
  }

  toggleBasePlanSubject$
  refreshCoverageSubject$;
  _toggleRefreshBasePlanComponent() {
    this.refreshBasePlanToggle = false;
    setTimeout(() => { this.refreshBasePlanToggle = true; }, 300);
  }

  refreshCoverageToggle = true;
  _toggleRefreshCoverageComponent() {
    this.refreshCoverageToggle = false;
    setTimeout(() => { this.refreshCoverageToggle = true; }, 300);
  }

  saveSelectedBenefits(){}

  expandBenefit(event: NzFormatEmitEvent): void{
    console.log(event);
  }

  checkBenefit(event: NzFormatEmitEvent): void{
    console.log(event);
  }

  chooseBenefit(event: NzFormatEmitEvent): void {
    console.log(event);
    this.selectedCoverageFromTree = event.keys ? event.keys[0] : "";
  }

  chosenBenefitsList = [];
  expandChosenBenefitsList = [];
  selectedCoverageListForTree = [];
  selectedCoverageFromTree: string;
  generateUIcoverageBenefitTree(){
    if(this.product && this.product.productId){
      let selectedProductData = this.productData.filter(item => item.productId === this.product.productId).find(()=> true);
      if(selectedProductData && this.commonUtilty.isArrayIterable(selectedProductData['productRiderAssociationList'])){
        selectedProductData['productRiderAssociationList'].forEach(coverage => {
          if(coverage.associationTypeCd == "MANDATORY"){
            let nodeObj = {
              title : coverage.riderDesc,
              key : coverage.riderCd,
              disableCheckbox : true, 
              children : this.createTreeData(coverage.productRiderBenefitList,'MANDATORY', true)
            }
            this.nodes.push(nodeObj);
            this.chosenBenefitsList.push(coverage.riderCd);
            this.expandChosenBenefitsList.push(coverage.riderCd);
            if(!this.commonUtilty.isArrayIterable(this.selectedCoverageListForTree)){
              this.selectedCoverageListForTree.push(coverage.riderCd);
              this.selectedCoverageFromTree = coverage.riderCd ? coverage.riderCd : "";
            }
          }else if(coverage.associationTypeCd == "OPTIONAL"){
            let nodeObj = {
              title : coverage.riderDesc,
              key : coverage.riderCd,
              children : this.createTreeData(coverage.productRiderBenefitList, 'OPTIONAL')
            }
            this.nodes.push(nodeObj);
          }
        });
      }
    }  
  }

  createTreeData(benefitList,isMandatory, isDisabled?){
    let tempList = []
    if(this.commonUtilty.isArrayIterable(benefitList)){
      benefitList.forEach(benefit => {
          let nodeObj = {
            title : benefit.benefitName || benefit.benefitId,
            key : benefit.benefitId,
            isLeaf : true,
            disabled: isDisabled
            //children : this.createTreeData(benefit.benefitList)
          }
          tempList.push(nodeObj);
          if(isMandatory == 'MANDATORY'){
            this.chosenBenefitsList.push(nodeObj.key);
          }
      });
    }
    return tempList;
  }

  benefitDataList = [];
  generateUIcoverageBenefitForPanel(){
    if(this.product && this.product.productId){
      let selectedProductData = this.productData.filter(item => item.productId === this.product.productId).find(()=> true);
      if(selectedProductData && this.commonUtilty.isArrayIterable(selectedProductData['productRiderAssociationList'])){
        selectedProductData['productRiderAssociationList'].forEach(coverage => {
          if(coverage.associationTypeCd == "MANDATORY"){
            if(this.commonUtilty.isArrayIterable(this.mandatoryCoverageObjList)){
              let index = this.mandatoryCoverageObjList.indexOf((element) => element.riderCd == coverage.riderCd);
              this.mandatoryCoverageObjList.forEach((element, i) => {
                if(element.riderCd == coverage.riderCd){
                  index = i;
                }
              });
              if(this.mandatoryCoverageObjList[index]){
                this.mandatoryCoverageObjList[index]['productRiderBenefitList'] = coverage.productRiderBenefitList;
              }
            }            
          }else if(coverage.associationTypeCd == "OPTIONAL"){
            if(this.commonUtilty.isArrayIterable(this.additionalCoverageObjList)){
              let index = this.additionalCoverageObjList.indexOf((element) => element.riderCd == coverage.riderCd);
              this.additionalCoverageObjList.forEach((element, i) => {
                if(element.riderCd == coverage.riderCd){
                  index = i;
                }
              });
              if(this.additionalCoverageObjList[index]){
                this.additionalCoverageObjList[index]['productRiderBenefitList'] = coverage.productRiderBenefitList;
              }
            }
          }
        });
      }
    }
  }

  nodes = [];
  coverageView = 'panelView';
  isExpand: boolean = true;
  expandCollapsePanel(event){
    this.isExpand = event
  }

  setRider(rider, index){
    if(rider && this.commonUtilty.isArrayIterable(this.additionalCoveragesComponentData) && this.additionalCoveragesComponentData[index]
       && !this.additionalCoveragesComponentData[index]['riderCd']){
      this.additionalCoveragesComponentData[index]['riderCd'] = rider;
    }
  }

}



